import { useState, useEffect, useRef } from 'react'
import { KTIcon } from '../../../../../_metronic/helpers'
import axios from 'axios'
import clsx from 'clsx'
import { toast } from 'react-toastify'
import { ConfirmSegregateModal } from './ConfirmSegregateModal/ConfirmSegregateModal'

const AddressDetailModal = ({
  listing,
  getListing,
  onLatLngChange = () => {},
  setOpenAddressModal
}) => {
const [isLoading, setIsLoading] = useState(false)
const [fullAddress, setFullAddress] = useState(listing?.full_address)
const [slug, setSlug] = useState(listing?.details_slug || '')
const [details, setDetails] = useState(listing?.details)
const [zipCode, setZipCode] = useState(listing?.zip_code)
const [state, setState] = useState(listing?.state || '')
const [city, setCity] = useState(listing?.city || '')
const [lat, setLat] = useState(listing?.lat)
const [lng, setLng] = useState(listing?.lng)
const prefixRef = useRef(null);
const [prefixWidth, setPrefixWidth] = useState(0);
const [openConfirmSegregateModal, setOpenConfirmSegregateModal] = useState(false)

  useEffect(() => {
    if (prefixRef.current) {
      setPrefixWidth(prefixRef.current.offsetWidth + 16);
    }
  }, [state, city]);

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const updateAddress = () => {
    setIsLoading(true)
    axios.put(`${process.env.REACT_APP_API_URL}/listing/${listing?.listing_id}`, {
      full_address: fullAddress,
      details_slug: slug,
      details: details,
      zip_code: zipCode,
      state: state,
      city: city,
      lat: lat,
      lng: lng
    }).then(() => {
      setIsLoading(false)
      setOpenAddressModal(false)
      getListing()
      setIsLoading(false)
      toast.success('Address Updated Successfully')
    }).catch((err) => {
      setIsLoading(false)
      if (err && err.response && err.response?.data && err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Technical Error, Please Try Again");
      }
    })
  }

  const isDisabled = () => {
    return !fullAddress ||
          !slug ||
          !details ||
          !zipCode ||
          !state ||
          !city ||
          !lat ||
          !lng ||
          isLoading
  }

  const handleSegregate = async () => {
      try {
          setIsLoading(true)
          await axios.put(`${process.env.REACT_APP_API_URL}/listing/${listing?.listing_id}`, {
              details_slug: slug + '-bobtails'
          })
          await getListing()
          setOpenAddressModal(false)
          toast.success('Listing segregated successfully')
      } catch (err) {
          toast.error("Technical error while segregating, please try again");
      } finally {
          setIsLoading(false)
      }
  }

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className={`modal-dialog modal-dialog-centered mw-700px`}>
          <div className='modal-content'>
            {/* header */}
            <div className='modal-header py-3'>
              <h2 className='fw-bolder mb-0'>Update Address</h2>
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={() => {
                  setOpenAddressModal(false)
                }}
                style={{ cursor: 'pointer' }}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>
            {/* body */}
            <div className={`modal-body scroll-y mx-5 mx-xl-15 my-5 `}>
              <div
                className="d-flex flex-column scroll-y me-n7 pe-7"
                id="kt_modal_add_user_scroll"
                data-kt-scroll="true"
                data-kt-scroll-activate="{default: false, lg: true}"
                data-kt-scroll-max-height="auto"
                data-kt-scroll-dependencies="#kt_modal_add_user_header"
                data-kt-scroll-wrappers="#kt_modal_add_user_scroll"
                data-kt-scroll-offset="300px"
              >
                <div className="fv-row mb-5">
                  <label className="required fw-bold fs-6 mb-2">Full Address</label>
                  <input
                    placeholder="Full Address"
                    type="text"
                    name="full_address"
                    className={clsx("form-control form-control-solid mb-3 mb-lg-0")}
                    value={fullAddress}
                    onChange={(e) => setFullAddress(e.target.value)}
                    autoComplete="off"
                  />
                </div>

                <div className="fv-row mb-5">
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                    <label className="required fw-bold fs-6 mb-2">Slug</label>
                    {listing?.status === 1 && 
                    <button
                      className='badge fw-bold fs-6 text-white my-0 rounded py-2 px-2 mb-1 d-flex justify-content-center align-items-center'
                        style={{
                            backgroundColor: slug.indexOf('-bobtails') === -1 ? '#ffa459' : 'rgb(46, 204, 113)',
                            opacity: slug.indexOf('-bobtails') === -1 ? 1 : '0.6',
                            cursor: slug.indexOf('-bobtails') === -1 ? 'pointer' : 'not-allowed'
                        }}
                        disabled={slug.indexOf('-bobtails') !== -1}
                        onClick={() => setOpenConfirmSegregateModal(true)}
                    >
                        {slug.indexOf('-bobtails') === -1 ? 'Segregate this listing' : 'Segregated'}
                    </button>
                    }
                  </div>
                  <div className='position-relative'>
                   {<span
                      ref={prefixRef}
                      className='position-absolute top-50 translate-middle-y badge badge-info fs-6 text-white'
                      style={{ left: '1rem', pointerEvents: 'none' }}
                    >
                      {`${listing?.state_slug}/`}{`${listing?.city_slug}/`}
                    </span>
                    }
                    <input
                      type="text"
                      name="slug"
                      className={clsx("form-control form-control-solid mb-3 mb-lg-0")}
                      style={{ paddingLeft: `${prefixWidth}px` }}
                      value={slug}
                      onChange={(e) => setSlug(e.target.value)}
                      autoComplete="off"
                    />
                  </div>
                </div>

                <div className="fv-row mb-5">
                  <label className="required fw-bold fs-6 mb-2">Details</label>
                  <input
                    placeholder="Details"
                    type="text"
                    name="details"
                    className={clsx("form-control form-control-solid mb-3 mb-lg-0")}
                    value={details}
                    onChange={(e) => setDetails(e.target.value)}
                    autoComplete="off"
                  />
                </div>
                
                <div className="d-flex gap-4 mb-5">
                  <div className='fv-row'>
                  <label className="required fw-bold fs-6 mb-2">City</label>
                  <input
                    placeholder="City"
                    type="text"
                    name="city"
                    className={clsx("form-control form-control-solid mb-3 mb-lg-0")}
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    autoComplete="off"
                  />
                  </div>
                  <div className='fv-row'>
                  <label className="required fw-bold fs-6 mb-2">State</label>
                  <input
                    placeholder="State"
                    type="text"
                    name="state"
                    className={clsx("form-control form-control-solid mb-3 mb-lg-0")}
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    autoComplete="off"
                  />
                  </div>
                  <div className='fv-row'>
                  <label className="required fw-bold fs-6 mb-2">Zip Code</label>
                  <input
                    placeholder="Zip Code"
                    type="text"
                    name="zip_code"
                    className={clsx("form-control form-control-solid mb-3 mb-lg-0")}
                    value={zipCode}
                    onChange={(e) => setZipCode(e.target.value)}
                    autoComplete="off"
                  />
                  </div>
                </div>
                <div className="d-flex gap-4">
                  <div className="d-flex flex-column w-100 gap-2">
                    <span className='required fw-bold fs-6'>Latitude</span>
                    <input
                      className="form-control form-control-solid"
                      placeholder="Enter Latitude"
                      value={lat}
                      onChange={(e) => {
                        onLatLngChange(e, setLat)
                      }}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setLat(listing?.lat)
                        }
                      }}
                    />
                  </div>
                  <div className="d-flex flex-column w-100 gap-2">
                    <span className='required fw-bold fs-6' style={{ fontWeight: "600" }}>Longitude</span>
                    <input
                      className="form-control form-control-solid"
                      placeholder="Enter Longitude"
                      value={lng}
                      onChange={(e) => {
                        onLatLngChange(e, setLng)
                      }}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setLng(listing?.lng)
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* begin::Actions */}
              <div className="text-center pt-10">
                <button
                  type="reset"
                  onClick={() => setOpenAddressModal(false)}
                  className="btn btn-light mx-3"
                  data-kt-users-modal-action="cancel"
                >
                  Discard
                </button>

                <button
                  type="submit"
                  className="btn btn-main text-white"
                  data-kt-users-modal-action="submit"
                  disabled={isDisabled()}
                  onClick={updateAddress}
                >
                  <span className="indicator-label">Update</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
      {openConfirmSegregateModal &&
      <ConfirmSegregateModal setOpenConfirmSegregateModal={setOpenConfirmSegregateModal} isLoading={isLoading} handleSegregate={handleSegregate} />
      }
    </>
  )
}

export { AddressDetailModal }
